import { NgStyle } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { NgIconComponent } from '@ng-icons/core';
import { ButtonDirective } from '../button/button.directive';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { DictionaryService } from '../../services/dictionary.service';

interface buttonSize {

}

@Component({
  selector: 'app-export-button',
  imports: [ButtonDirective, NgIconComponent, LoadingSpinnerComponent, NgStyle],
  templateUrl: './export-button.component.html',
  styleUrl: './export-button.component.scss'
})
export class ExportButtonComponent {
  export = output<void>();
  exportLoading = input<boolean>(false);
  size = input<'rg' | 'sm'>('rg');
  dictionaryService = inject(DictionaryService);
  width = input<string>('');
}
